module.exports = __webpack_public_path__ + "assets/img/Payoneer.098bc989.png";